import { AuthService } from '@services/auth.service';
import { SessionService } from '@services/session.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { EnumAPIStatus } from '@api/AbstractAPI';
import { AlertController, LoadingController, ToastController } from '@ionic/angular';
import { BasePage, EnumGenericRoleActionAlerts } from '@pages/BasePage';
import { UsersService } from '@services/users.service';
import { ISession } from '@models/AuthUser';
import { FormValidators } from '@validators/form.validators';

@Component({
	selector: 'app-account',
	templateUrl: './account.page.html',
	styleUrls: ['./account.page.scss'],
})
export class AccountPage extends BasePage implements OnInit {

	public IsCompleted: boolean = false;
	public IsEditing: boolean = false;

	public Form: FormGroup;
	public FormPassword: FormGroup;

	public UserTemplates: any[] = [];

	private session: ISession;

	private data;

	constructor(protected ActivatedRoute: ActivatedRoute,
		protected LoadingController: LoadingController,
		protected ToastController: ToastController,
		protected AlertController: AlertController,
		protected UsersService: UsersService,
		private SessionService: SessionService,
		private AuthService: AuthService
	) {
		super(ActivatedRoute, LoadingController, ToastController, AlertController);

		this.createFormElements();
		this.createFormElementsPassword();

	}

	async ngOnInit() {

		this.IsCompleted = false;

		await this.ShowLoading();

		await this.onLoadData();

		this.createFormElements();
		this.createFormElementsPassword();

		await this.DismissLoading();

		this.IsCompleted = true;
	}

	async onCanLeavePage(ev: any) {

		if ((!this.Form.dirty && !this.FormPassword.dirty) || !this.IsEditing) return true;

		const { role } = await this.ShowAlert('Aviso', 'Pretende sair da página sem guardar');

		return role == EnumGenericRoleActionAlerts.Confirm;
	}

	/**
	 * 
	 * @param data 
	 */
	private createFormElements(data: any = this.data) {

		// console.log(data);

		this.Form = new FormGroup({
			Id: new FormControl(data?.Id || null),
			Name: new FormControl(data?.Name || null, [Validators.required, Validators.minLength(2)]),
			Username: new FormControl(data?.Username || null, []),
			Email: new FormControl(data?.Email || null, []),

			RegistDate: new FormControl(data?.RegistDate || null),
			Role: new FormControl({ value: data?.IdRole || null, disabled: true }),
			Template: new FormGroup({
				Id: new FormControl({ value: data?.Template?.Id || null, disabled: true }),
				Name: new FormControl({ value: data?.Template?.Name || null, disabled: true })
			}),
		});

		this.Form.disable();

	}

	/**
	 * 
	 * @param data 
	 */
	private createFormElementsPassword(data: any = this.data) {

		this.FormPassword = new FormGroup({
			Id: new FormControl(data?.Id || null),
			PasswordOld: new FormControl(null, [Validators.required]),
			Password: new FormControl(null, [Validators.required, FormValidators.PasswordStrengthValidator]),
			PasswordMatch: new FormControl(null, [Validators.required, FormValidators.PasswordStrengthValidator])
		},
			{
				validators: [FormValidators.MatchValidator("Password", "PasswordMatch")]
			}
		);

		this.FormPassword.disable();
	}

	/**
	 * 
	 * @returns 
	 */
	private async onLoadData() {

		this.session = this.SessionService.Get();

		const responseUser = await this.AuthService.GetUserInfo();

		// const responseTemplates = await this.UsersService.GetRoleUserPermissionListTemplate();

		this.data = responseUser;

		return this.data;

	}

	OnEdit(ev?: any) {

		this.IsEditing = true;
		// this.Form.enable();
		this.Form.get('Name').enable();
	}

	async OnCancelEdit(ev?: any) {

		if (!this.Form.dirty) {
			this.IsEditing = false;

			this.Form.disable();
			return;
		}

		const { role } = await this.ShowAlert()

		if (role != EnumGenericRoleActionAlerts.Confirm) return;

		this.IsEditing = false;

		this.createFormElements();
	}

	/**
	 * 
	 * @param ev 
	 * @returns 
	 */
	async OnSave(ev?: any) {

		if (!this.Form.dirty) return await this.ShowToast('Não foram encontradas alterações.');

		this.Form.markAllAsTouched();

		if (this.Form.invalid)
			return await this.ShowToast('Preencha todos os campos assinalados.');


		const data = {
			// "code": "string",
			// "idEntity": "string",
			idUser: this.Form.get('Id').value || '',
			// "idRole": 0,
			name: this.Form.get('Name').value || '',
			// "username": "string",
			// "email": "string",
		};

		console.log(data);

		await this.ShowLoading();

		const response = await this.AuthService.ChangePersonalData(data);

		await this.DismissLoading();

		this.ShowToast(response?.Error?.Message);

		if (response.Status == EnumAPIStatus.Success) {

			this.data.Name = data.name;
			this.IsEditing = false;
			this.createFormElements();

			// save user data on local
			this.session.UserData = this.data;
			this.SessionService.SaveSession(this.session);
		}

	}

	/**
	 * 
	 * @param ev 
	 * @returns 
	 */
	async OnCancelPassword(ev?: any) {

		if (!this.FormPassword.dirty) {
			this.IsEditing = false;

			this.FormPassword.disable();
			return;
		}

		const { role } = await this.ShowAlert()

		if (role != EnumGenericRoleActionAlerts.Confirm) return;

		this.createFormElementsPassword();
	}

	/**
	 * 
	 * @param ev 
	 */
	OnEditPassword(ev?: any) {

		this.IsEditing = true;
		this.FormPassword.enable();
	}

	/**
	 * 
	 * @param ev 
	 * @returns 
	 */
	async OnChangePassword(ev?: any) {

		if (!this.FormPassword.dirty) return await this.ShowToast('Não foram encontradas alterações.');

		this.FormPassword.markAllAsTouched();

		if (this.FormPassword.invalid)
			return await this.ShowToast('Preencha todos os campos assinalados.');

		const data = {
			// "code": "string",
			// "idEntity": "string",
			idUser: this.FormPassword.get('Id').value || '',
			// "idRole": 0,
			// "name": "string",
			// "username": "string",
			// "email": "string",
			oldPassword: this.FormPassword.get('PasswordOld').value || '',
			password: this.FormPassword.get('Password').value || '',
			confirmPassword: this.FormPassword.get('Password').value || ''
		};

		console.log(data);

		await this.ShowLoading();

		const response = await this.AuthService.ChangePassword(data);

		await this.DismissLoading();

		this.ShowToast(response?.Error?.Message);

		if (response.Status == EnumAPIStatus.Success) {

			this.IsEditing = false;
			this.FormPassword.reset();
			this.FormPassword.disable();
		}

	}

}
